import React from 'react';

const TypeContext = React.createContext();

const withTypeContext = (WrappedComponent) => ({context, ...props}) => (
    <TypeContext.Consumer>{(type) => <WrappedComponent context={{...context, type}} {...props} />}</TypeContext.Consumer>
);

export {TypeContext, withTypeContext};
export default TypeContext.Provider;
